export default function registUser (lf) {
  lf.register('user', ({ PolygonNode, PolygonNodeModel, h }) => {
    class Node extends PolygonNode {
      getIconShape () {
        const {model} = this.props
        const {width, height} = model
        const {stroke} = model.getNodeStyle()
        return h(
          "svg",{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:width/2-23,y:height/2-20,"width":"46","height":"40","viewBox":"0 0 46 40","fill":"none"},
          h("g",{"opacity":"1","transform":"translate(0 0)  rotate(0 23 19.999999999999975)"}),
          h("g",{"mask":"url(#bg-mask-0)"}),
          h("path",{"id":"分组 1","fill-rule":"evenodd","style":"fill:#00BAAD","transform":"translate(0.06201603982300677 2.5199999999999756)  rotate(0 22.98054766031196 16.23999999999998)","opacity":"1","d":"M45.96 5C45.96 3.32 45.46 2.07 44.47 1.24C43.48 0.41 42.15 0 40.49 0L5.14 0C3.51 0 2.24 0.46 1.35 1.38C0.45 2.3 0 3.48 0 4.92L0 27.6C0 28.27 0.14 28.89 0.41 29.48C0.68 30.07 1.05 30.58 1.51 31.02C1.97 31.46 2.52 31.81 3.14 32.08C3.77 32.35 4.44 32.48 5.14 32.48L40.74 32.48C41.44 32.48 42.12 32.34 42.76 32.06C43.4 31.78 43.95 31.4 44.43 30.92C44.91 30.44 45.28 29.88 45.55 29.24C45.83 28.6 45.96 27.92 45.96 27.2L45.96 5Z M8.77297 13.84C9.13297 14.19 9.53297 14.46 10.003 14.66C10.463 14.86 10.953 14.96 11.473 14.96C12.043 14.96 12.563 14.86 13.043 14.66C13.513 14.46 13.923 14.19 14.263 13.84C14.603 13.49 14.883 13.09 15.083 12.64C15.283 12.19 15.393 11.69 15.393 11.16C15.393 10.07 15.023 9.17 14.283 8.46C13.553 7.75 12.613 7.4 11.473 7.4C10.953 7.4 10.463 7.49 10.003 7.68C9.53297 7.87 9.13297 8.13 8.77297 8.46C8.42297 8.79 8.14297 9.19 7.94297 9.66C7.73297 10.13 7.63297 10.63 7.63297 11.16C7.63297 11.69 7.73297 12.19 7.94297 12.64C8.14297 13.09 8.42297 13.49 8.77297 13.84Z M17.8831 21.24C17.8831 20.73 17.7731 20.25 17.5731 19.78C17.3631 19.31 17.0931 18.91 16.7531 18.58C16.4131 18.25 16.0031 17.98 15.5331 17.78C15.0531 17.58 14.5631 17.48 14.0431 17.48L8.94307 17.48C7.87307 17.48 6.98307 17.85 6.24307 18.58C5.51307 19.31 5.14307 20.2 5.14307 21.24L5.14307 21.4L5.14307 25L17.8831 25L17.8831 21.4L17.8831 21.24Z M37.9589 22.86C37.6589 22.58 37.2389 22.44 36.6989 22.44L24.5289 22.44C23.9889 22.44 23.5789 22.58 23.3089 22.86C23.0389 23.14 22.8989 23.47 22.8989 23.84C22.8989 24.21 23.0389 24.53 23.3089 24.8C23.5789 25.07 23.9689 25.2 24.4889 25.2L36.8189 25.2C37.3589 25.2 37.7589 25.07 38.0189 24.8C38.2789 24.53 38.4089 24.21 38.4089 23.84C38.4089 23.47 38.2589 23.14 37.9589 22.86Z M24.4081 17.28C23.8681 17.28 23.4681 17.41 23.2281 17.68C22.9781 17.95 22.8581 18.28 22.8581 18.68C22.8581 19.05 22.9781 19.37 23.2081 19.64C23.4381 19.91 23.8281 20.04 24.3681 20.04L36.8581 20.04C37.3981 20.04 37.7981 19.91 38.0381 19.64C38.2881 19.37 38.4081 19.05 38.4081 18.68C38.4081 18.28 38.2981 17.95 38.0581 17.68C37.8281 17.41 37.4481 17.28 36.8981 17.28L24.4081 17.28Z M28.614 14.96L36.904 14.96C37.304 14.96 37.664 14.83 37.964 14.56C38.264 14.29 38.414 13.97 38.414 13.6C38.414 13.23 38.264 12.93 37.964 12.7C37.664 12.47 37.304 12.36 36.904 12.36L28.614 12.36C28.204 12.36 27.854 12.47 27.574 12.7C27.284 12.93 27.144 13.23 27.144 13.6C27.144 13.97 27.284 14.29 27.574 14.56C27.854 14.83 28.204 14.96 28.614 14.96Z "}),
          h("mask",{"id":"bg-mask-0","fill":"white"}),
          h("use",{"xlink:href":"#path_0"}),
          h("rect",{"id":"path_0","x":"0","y":"0","width":"46","height":"39.99999999999995"}),
        )
      }
      getShape () {
        const {model} = this.props
        const {width, height, x, y, points} = model
        const {fill, fillOpacity, strokeWidth, stroke, strokeOpacity,} = model.getNodeStyle()
        const transform = `matrix(1 0 0 1 ${x - width / 2} ${y - height / 2})`
        const pointsPath = points.map(point => point.join(',')).join(' ')
        return h(
          'g',
          {
            transform
          },
          [
            h("svg",{"xmlns":"http://www.w3.org/2000/svg","version":"1.1"}),
            h("rect",{"width":width,"height":height,"style":"fill:#ffffff;stroke-width:1;stroke:#aaaaaa;"}),
            this.getIconShape()
          ]
        )
      }
    }
    class Model extends PolygonNodeModel {
      constructor (data, graphModel) {
        data.text = {
          value: (data.text && data.text.value) || '',
          x: data.x,
          y: data.y + 50
        }
        super(data, graphModel)
        // 右键菜单自由配置，也可以通过边的properties或者其他属性条件更换不同菜单
        this.menu = [
          {
            className: 'lf-menu-delete',
            text: '删除',
            callback (node) {
              // const comfirm = window.confirm('你确定要删除吗？')
              lf.deleteNode(node.id)
            }
          },
          {
            text: '修改',
            className: 'lf-menu-item',
            callback (node) {
              lf.editText(node.id)
            }
          },
          {
            text: '复制',
            className: 'lf-menu-item',
            callback (node) {
              lf.cloneNode(node.id)
            }
          }
        ]
      }
      initNodeData(data) {
        super.initNodeData(data)
        const lenght = 35
        this.points = [
          [lenght, 0],
          [lenght * 2, lenght],
          [lenght, lenght * 2],
          [0, lenght]
        ]
      }
      // 自定义锚点样式
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.hover.r = 8;
        style.hover.fill = "rgb(24, 125, 255)";
        style.hover.stroke = "rgb(24, 125, 255)";
        return style;
      }
    }
    return {
      view: Node,
      model: Model
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/registerNode/registerUser.js